var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0082 2.01432C14.3811 1.64135 14.3811 1.03666 14.0082 0.663695C13.6352 0.290731 13.0305 0.290731 12.6575 0.663695L7.57708 5.74416L2.49662 0.663695C2.12365 0.290731 1.51896 0.290731 1.14599 0.663695C0.773031 1.03666 0.773031 1.64135 1.14599 2.01432L6.22646 7.09478L1.14599 12.1753C0.773031 12.5482 0.773031 13.1529 1.14599 13.5259C1.51896 13.8988 2.12365 13.8988 2.49662 13.5259L7.57708 8.4454L12.6575 13.5259C13.0305 13.8988 13.6352 13.8988 14.0082 13.5259C14.3811 13.1529 14.3811 12.5482 14.0082 12.1753L8.9277 7.09478L14.0082 2.01432Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.d197426be11e1335f842be7eca6f42fe.svg";
export { ForwardRef as ReactComponent };